export default "__VITE_ASSET__DQb_Dfl$__"